'use client'
import styles from './style.module.scss'
import { IBM_Plex_Mono } from 'next/font/google'
import { m, LazyMotion, domAnimation } from 'framer-motion'
import { useStore } from 'lib/store'
import { useMobileTabletDetect } from '@/hooks/useDeviceType'

const mono = IBM_Plex_Mono({
  subsets: ['latin'],
  weight: ['500'],
  display: 'swap',
})
const SwipeIcon = ({ className }) => {
  return (
    <svg className={`${className} ${styles.swipe}`}>
      <use xlinkHref="#iconSwipe">
        <svg id="iconSwipe" viewBox="0 0 63.357 76.865" fill="#fff">
          <path d="M62.857,37.865c-0.842-4.981-3.356-7.588-5.316-8.899c-1.912-1.278-3.899-1.771-5.449-1.936 c-1.998-2.674-4.875-4.133-8.19-4.133c-0.728,0-1.468,0.069-2.212,0.208c-1.968-2.249-4.672-3.474-7.718-3.474 c-0.056,0-0.112,0.001-0.169,0.001l-0.011-9.359h11.577l-4.34,4.34c-0.267,0.267-0.413,0.62-0.413,0.998 c0,0.378,0.148,0.733,0.413,1c0.268,0.267,0.623,0.413,1.001,0.413c0.377,0,0.732-0.146,0.999-0.413l6.916-6.915 c0.551-0.551,0.552-1.449,0.001-1.999l-6.738-6.738c-0.267-0.267-0.622-0.414-1-0.414c-0.377,0-0.732,0.148-0.999,0.414 c-0.268,0.267-0.415,0.622-0.414,1c0,0.378,0.147,0.731,0.414,0.998l4.491,4.492H33.681c-0.245-2.094-1.137-3.958-2.651-5.302 C29.473,0.761,27.416,0,25.238,0c-2.333,0-4.573,0.902-6.145,2.476c-1.325,1.327-2.088,3.038-2.308,4.97H4.658L9.15,2.955 c0.267-0.267,0.413-0.62,0.413-0.998c0.001-0.378-0.147-0.733-0.414-1C8.882,0.691,8.527,0.543,8.15,0.543 c-0.378,0-0.732,0.146-0.999,0.414L0.413,7.696c-0.551,0.551-0.551,1.449,0,1.999l6.915,6.915c0.268,0.267,0.623,0.413,1,0.413 c0.378,0,0.733-0.146,1-0.413c0.267-0.267,0.414-0.622,0.414-1c0-0.378-0.147-0.731-0.414-0.998l-4.339-4.34h11.701l0.018,14.295 l0.012,10.158c-2.284,1.221-3.864,3.155-4.596,5.644c-1.128,3.835-0.229,8.773,2.748,15.099c1.959,4.162,4.311,7.804,5.437,9.464 l0.499,6.643c0.223,2.966,2.728,5.29,5.702,5.29l23.674-0.029c2.856-0.004,5.29-2.142,5.662-4.974l0.92-7.002 C62.354,56.097,64.404,47.015,62.857,37.865z M53.551,63.179c-0.17,0.263-0.283,0.561-0.323,0.872l-0.964,7.342 c-0.137,1.047-1.029,1.766-2.085,1.767l-23.667-0.035c-0.001,0-0.002,0-0.003,0c-1.101,0-2.017-0.785-2.1-1.884l-0.529-7.014 c-0.028-0.372-0.153-0.712-0.365-1.019c-2.166-3.148-14.262-21.506-4.467-25.601c0.78-0.326,1.285-1.086,1.284-1.931 c-0.006-5.001-0.026-21.595-0.033-27.122c-0.004-3.295,2.467-4.944,4.939-4.944c2.467,0,4.934,1.644,4.938,4.933l0.015,12.729 c0.002,1.179,0.961,2.103,2.099,2.103c0.109,0,0.22-0.008,0.331-0.026c0.418-0.066,0.873-0.108,1.349-0.108 c1.778,0,3.852,0.595,5.441,2.797c0.395,0.547,1.027,0.846,1.682,0.846c0.184,0,0.37-0.024,0.554-0.072 c0.623-0.165,1.403-0.305,2.253-0.305c1.857,0,4.048,0.67,5.663,3.215c0.324,0.51,0.874,0.828,1.478,0.85 c2.134,0.077,7.089,1.012,8.253,7.893C60.374,44.845,59.877,53.402,53.551,63.179z"></path>
        </svg>
      </use>
    </svg>
  )
}
const MouseIcon = ({ className }) => {
  return (
    <svg className={`worklist__icon ${className}`}>
      <use xlinkHref="#iconScroll">
        <svg id="iconScroll" viewBox="0 0 75.116 77.101" fill="#fff">
          <path d="M24.568,77.101c-13.448,0-24.426-10.942-24.472-24.391L0,24.559C-0.047,11.065,10.895,0.046,24.39,0 c13.534,0,24.513,10.94,24.559,24.391l0.096,28.153c0.023,6.51-2.51,12.658-7.13,17.311c-4.62,4.651-10.75,7.226-17.26,7.247H24.568 z M24.402,3.542c-5.583,0.019-10.83,2.218-14.775,6.19c-3.944,3.972-6.106,9.233-6.087,14.816l0.097,28.151 c0.039,11.503,9.429,20.862,20.933,20.862c5.655-0.019,10.903-2.218,14.848-6.19c3.944-3.972,6.106-9.233,6.087-14.816 l-0.097-28.153c-0.04-11.503-9.429-20.86-20.931-20.86H24.402z M24.478,27.148c-1.212,0-2.201-0.984-2.205-2.197l-0.035-10.323 c-0.002-0.587,0.224-1.142,0.64-1.56c0.414-0.416,0.967-0.647,1.555-0.649c1.219,0,2.207,0.984,2.21,2.195l0.035,10.323 c0.005,1.215-0.98,2.207-2.196,2.21H24.478z M74.621,52.363c-0.316-0.313-0.735-0.485-1.18-0.485c-0.449,0-0.871,0.175-1.188,0.493 l-5.028,5.062l-0.073-21.14c0,0,0-0.001,0-0.001l-0.058-16.916l5.062,5.029c0.317,0.313,0.736,0.485,1.181,0.485 c0.45,0,0.872-0.177,1.189-0.495c0.315-0.317,0.487-0.739,0.485-1.188c0-0.445-0.176-0.865-0.494-1.182l-7.741-7.688 c-0.317-0.313-0.736-0.485-1.181-0.485c-0.45,0-0.872,0.177-1.189,0.495l-7.891,7.945c-0.316,0.319-0.488,0.739-0.486,1.186 c0.002,0.449,0.177,0.869,0.494,1.184c0.317,0.313,0.736,0.485,1.181,0.485c0.45,0,0.871-0.175,1.188-0.493l4.854-4.889 l0.072,20.764c0,0,0,0,0,0l0.056,16.539l-4.888-4.854c-0.316-0.313-0.735-0.485-1.179-0.485c-0.45,0-0.872,0.175-1.19,0.493 c-0.315,0.319-0.487,0.739-0.486,1.186c0.002,0.449,0.177,0.869,0.495,1.184l7.945,7.892c0.316,0.313,0.735,0.485,1.179,0.485 c0.45,0,0.872-0.175,1.189-0.493l7.689-7.742c0.316-0.319,0.488-0.739,0.486-1.186C75.115,53.1,74.939,52.68,74.621,52.363z"></path>
        </svg>
      </use>
    </svg>
  )
}
const KeyboardIcon = ({ className }) => {
  return (
    <svg className={`worklist__icon ${className}`}>
      <use xlinkHref="#iconArrowKey">
        <svg id="iconArrowKey" viewBox="0 0 118.671 77.456" fill="#fff">
          <path d="M71.423,36.241H47.247c-3.326,0-6.032-2.706-6.032-6.033V6.033C41.215,2.706,43.921,0,47.247,0h24.176 c3.326,0,6.032,2.706,6.032,6.033v24.174C77.456,33.534,74.749,36.241,71.423,36.241z M47.247,3.553 c-1.367,0-2.479,1.113-2.479,2.48v24.174c0,1.367,1.112,2.48,2.479,2.48h24.176c1.367,0,2.479-1.113,2.479-2.48V6.033 c0-1.367-1.112-2.48-2.479-2.48H47.247z M58.834,13.156l-4.683,8.111c-0.223,0.386,0.056,0.868,0.501,0.868h9.366 c0.445,0,0.723-0.482,0.501-0.868l-4.683-8.111C59.614,12.77,59.057,12.77,58.834,13.156z M47.247,41.215h24.176 c3.326,0,6.032,2.706,6.032,6.033v24.174c0,3.327-2.706,6.033-6.032,6.033H47.247c-3.326,0-6.032-2.706-6.032-6.033V47.248 C41.215,43.921,43.921,41.215,47.247,41.215z M71.423,73.903c1.367,0,2.479-1.113,2.479-2.48V47.248c0-1.367-1.112-2.48-2.479-2.48 H47.247c-1.367,0-2.479,1.113-2.479,2.48v24.174c0,1.367,1.112,2.48,2.479,2.48L71.423,73.903L71.423,73.903z M59.836,64.3 l4.683-8.111c0.223-0.386-0.056-0.868-0.501-0.868h-9.366c-0.445,0-0.723,0.482-0.501,0.868l4.683,8.111 C59.057,64.686,59.614,64.686,59.836,64.3z M36.241,47.247v24.176c0,3.326-2.706,6.032-6.033,6.032H6.033 C2.706,77.456,0,74.749,0,71.423V47.247c0-3.326,2.706-6.032,6.033-6.032h24.174C33.534,41.215,36.241,43.921,36.241,47.247z M3.553,71.423c0,1.367,1.113,2.479,2.48,2.479h24.174c1.367,0,2.48-1.112,2.48-2.479V47.247c0-1.367-1.113-2.479-2.48-2.479H6.033 c-1.367,0-2.48,1.112-2.48,2.479V71.423z M12.96,59.836l8.111,4.683c0.386,0.223,0.868-0.056,0.868-0.501v-9.366 c0-0.445-0.482-0.723-0.868-0.501l-8.111,4.683C12.574,59.057,12.574,59.614,12.96,59.836z M82.43,71.423V47.247 c0-3.326,2.706-6.032,6.033-6.032h24.174c3.327,0,6.033,2.706,6.033,6.032v24.176c0,3.326-2.706,6.032-6.033,6.032H88.463 C85.136,77.456,82.43,74.749,82.43,71.423z M115.118,47.247c0-1.367-1.113-2.479-2.48-2.479H88.463c-1.367,0-2.48,1.112-2.48,2.479 v24.176c0,1.367,1.113,2.479,2.48,2.479h24.174c1.367,0,2.48-1.112,2.48-2.479L115.118,47.247L115.118,47.247z M105.712,58.834 L97.6,54.151c-0.386-0.223-0.868,0.056-0.868,0.501v9.366c0,0.445,0.482,0.723,0.868,0.501l8.111-4.683 C106.097,59.614,106.097,59.057,105.712,58.834z"></path>
        </svg>
      </use>
    </svg>
  )
}
const IndicatorIcon = ({ children, text = '' }) => {
  return (
    <>
      {children}
      <p className=" ml-2 whitespace-nowrap text-xs  sm:text-sm">{text}</p>
    </>
  )
}

export default function Indicator({ currentIndex, total }): React.ReactElement {
  const setCurrentProject = useStore(
    ({ setCurrentProject }) => setCurrentProject
  )
  const isShowIndicator = useStore(({ isShowIndicator }) => isShowIndicator)
  const isMobile = useMobileTabletDetect()
  const variantsIndicator = {
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
      },
    },
    hide: {
      y: 20,
      opacity: 0,
      transition: {
        duration: 0.4,
      },
    },
  }
  const variants = {
    show: {
      opacity: 1,
      y: 0,
      color: '#ffffff',
      transition: {
        duration: 0.4,
      },
    },
    hide: {
      y: 20,
      opacity: 0,
      color: '#000000',
    },
  }
  return (
    <>
      {
        <LazyMotion features={domAnimation}>
          <m.div
            className="instructor absolute bottom-[70px] left-[calc(50%-150px)] flex w-[300px] cursor-default  items-center justify-center md:bottom-[70px]"
            variants={variantsIndicator}
            animate={isShowIndicator ? 'show' : 'hide'}
            initial="hide"
          >
            {isMobile ? (
              <IndicatorIcon text="swipe and tap to view more details">
                <SwipeIcon className="h-[30px] w-[30px]" />
              </IndicatorIcon>
            ) : (
              <>
                <IndicatorIcon text="press arrow key">
                  <KeyboardIcon className="h-[40px] w-[40px]" />
                </IndicatorIcon>
                <span className="w-4"></span>
                <IndicatorIcon text="mouse scroll">
                  <MouseIcon className="h-[30px] w-[30px]" />
                </IndicatorIcon>
              </>
            )}
          </m.div>
        </LazyMotion>
      }

      <div
        className={`indicator flex justify-between ${styles.wrapper} ${mono.className}`}
      >
        <button
          type="button"
          role="button"
          name="back"
          aria-label="back"
          className={`${styles.arrow} ${styles['arrow-left']}`}
          onClick={() => setCurrentProject(currentIndex - 1)}
        >
          <LazyMotion features={domAnimation}>
            <m.span
              variants={variants}
              animate={'show'}
              initial="hide"
              key={currentIndex}
              className={`${styles.indicator}`}
            >
              {currentIndex + 1}
            </m.span>
          </LazyMotion>
        </button>
        <span className={`${styles.splash}`}></span>

        <button
          type="button"
          role="button"
          name="back"
          aria-label="next"
          className={`${styles.arrow} ${styles['arrow-right']}`}
          onClick={() => setCurrentProject(currentIndex + 1)}
        >
          <LazyMotion features={domAnimation}>
            <m.span
              variants={variants}
              animate={'show'}
              initial="hide"
              key={total}
              className={`${styles.indicator}`}
            >
              {total}
            </m.span>
          </LazyMotion>
        </button>
      </div>
    </>
  )
}
